import { useEffect, useState, useCallback } from 'react'
import { getAgami } from '../utils/helpers/user-spot.helpers'
import { useSessionContext } from '../contexts/SessionContext'
import { AgamiSpot } from '../types/supabase'

interface UseAgamiParams {
  agamiId: string
}

interface UseAgamiReturn {
  agami: AgamiSpot | null
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useAgami = ({ agamiId }: UseAgamiParams): UseAgamiReturn => {
  const { user } = useSessionContext()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [agami, setAgami] = useState<AgamiSpot | null>(null)

  const fetchAgami = useCallback(async (): Promise<void> => {
    if (!agamiId) return
    setIsLoading(true)
    const { agamiData, error } = await getAgami({ agamiId })

    if (error) {
      // Error handling could be added here
    }

    if (error || !agamiData) {
      setIsLoading(false)
      return
    }

    setAgami(agamiData)
    setIsLoading(false)
  }, [agamiId])

  useEffect(() => {
    if (!user) {
      return
    }

    fetchAgami()
  }, [user, fetchAgami])

  return { agami, isLoading, refetch: fetchAgami }
}
